<template>
  <div style="display: table;">
    <a-form :form="editForm" @submit="handleSubmit" autocomplete="off">
      <a-row :gutter="10" type="flex">
        <!-- 选房间类型 -->
        <a-col style="width: 80px;">
          <a-form-item
            label="RM Pref."
          >
            <a-select
              v-decorator="[
                'roomPreferred',
                {rules: [{ required: false, message: 'Please select roomPreferred' }]}
              ]"
              :showArrow="true"
            >
              <!-- <a-select-option value="">N/A</a-select-option> -->
              <a-select-option value="1">TWN</a-select-option>
              <a-select-option value="2">DBL</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 餐食 -->
        <a-col style="width: 300px;">
          <a-form-item
            label="Meals Restrictions"
          >
            <a-select
              :dropdownMatchSelectWidth="false"
              mode="multiple"
              @change="handleMealsRequestChange"
              v-decorator="[
                'mealsRequest',
                {rules: [{ required: false, message: 'Please select Meals Request' }]}
              ]"
              :showArrow="true"
            >
              <a-select-option v-for="i in mealsList" :key="'mealsRequest-' + i.code" :value="i.code" :disabled="i.disabled" :title="singleNameA(i.enName, i.twName)">
                {{ singleNameA(i.enName, i.twName) }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 要求 -->
        <a-col style="width: 300px;">
          <a-form-item
            label="Motion sickness"
          >
            <a-select
              :dropdownMatchSelectWidth="false"
              mode="multiple"
              @change="handleSpecialRequestChange"
              v-decorator="[
                'specialRequest',
                {rules: [{ required: false, message: 'Please select Special Request' }]}
              ]"
              :showArrow="true"
            >
              <a-select-option v-for="i in specialList" :key="'mealsRequest-' + i.code" :value="i.code" :disabled="i.disabled" :title="singleNameA(i.enName, i.twName)">
                {{ singleNameA(i.enName, i.twName) }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- <a-col style="width: 300px;">
          <a-form-item
            label="Internal note"
          >
            <a-textarea
              v-decorator="[
                'specialNote',
                {rules: [{ required: false, message: 'Please input your Special Note' }]}
              ]"
              placeholder="Please input your Special Note!"
              style="vertical-align: top; margin-top: 4px;"
              auto-size
            />
          </a-form-item>
        </a-col> -->
      </a-row>
    </a-form>
    <customer-airlines :ffpList="editData.ffpList" :airlineList="airlineList" :isEditTour="isEditTour" :globalCode="tourData.globalCode" ref="customerAirlines"></customer-airlines>
    <div style="margin-top: 14px;text-align: right;">
      <a-button type="primary" :loading="saving" @click="handleSave">Save</a-button>
      <a-button style="margin-left: 8px;" @click="handleCancel">Close</a-button>
    </div>
  </div>
</template>

<script>
import pick from 'lodash.pick'
import CustomerApi from '@/api/api-cdb-custome-v2'
import CustomerAirlines from './CdbCustomerAirlinesFrequentFlyer'

export default {
  name: 'CdbCustomerTourEdit',
  components: {
    CustomerAirlines
  },
  props: {
    customerId: {
      type: String,
      required: true
    },
    tourData: {
      type: Object,
      required: true
    },
    mealsList: {
      type: Array,
      default: () => []
    },
    specialList: {
      type: Array,
      default: () => []
    },
    airlineList: {
      type: Array,
      default: () => []
    },
    isEditTour: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      saving: false,
      editForm: this.$form.createForm(this),
      editData: this.tourData
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    // 初始化数据
    async loadData() {
      try {
        const vueData = this.copyDataByJSON(this.editData)
        const editData = pick(vueData, ['mealsRequest', 'specialRequest', 'specialNote','roomPreferred' ])
        // 餐食需求
        if (editData.mealsRequest && editData.mealsRequest !== '') {
          editData.mealsRequest = editData.mealsRequest.split(',')
          editData.mealsRequest = editData.mealsRequest.slice(0, editData.mealsRequest.length - 1)
        } else {
          editData.mealsRequest = []
        }
        // 特别需求
        if (editData.specialRequest && editData.specialRequest !== '') {
          editData.specialRequest = editData.specialRequest.split(',')
          editData.specialRequest = editData.specialRequest.slice(0, editData.specialRequest.length - 1)
        } else {
          editData.specialRequest = []
        }
        this.$nextTick(() => {
          this.editForm.setFieldsValue(editData)
          this.handleMealsRequestChange(editData.mealsRequest)
          this.handleSpecialRequestChange(editData.specialRequest)
        })
      } catch (e) {
        console.log('error', e)
        this.loading = false
      }
    },
    // Meals 限制
    handleMealsRequestChange (newValue) {
      const mealsList = this.mealsList
      if (mealsList && mealsList.length > 0) {
        mealsList.forEach(i => {
          i.disabled = false
          if (newValue && newValue.length > 0) {
            if (newValue.includes('0') && i.code !== '0') {
              i.disabled = true
            }
            if (!newValue.includes('0') && i.code === '0') {
              i.disabled = true
            }
          }
          })
      }
    },
    // Special 限制
    handleSpecialRequestChange (values) {
      const specialList = this.specialList
      if (specialList && specialList.length > 0) {
        specialList.forEach(i => {
          i.disabled = false
          if (values && values.length > 0) {
            if (values.includes('0') && i.code !== '0') {
                i.disabled = true
              }
              if (!values.includes('0') && i.code === '0') {
                i.disabled = true
              }
           }
        })
      }
    },
    handleSubmit (e) {
      e.preventDefault()
    },
    // 父组件调用校验方法
    validateTourForm () {
      const that = this
      const editForm = that.editForm
      return new Promise((resolve, reject) => {
        editForm.validateFields((err) => {
          if (err) {
            reject()
            return
          }
          var formData = editForm.getFieldsValue()
          // 餐食需求
          if (formData.mealsRequest && formData.mealsRequest.length > 0) {
            formData.mealsRequest = formData.mealsRequest.join(',')
            formData.mealsRequest = formData.mealsRequest + ','
          } else {
            formData.mealsRequest = null
          }
          // 特别需求
          if (formData.specialRequest && formData.specialRequest.length > 0) {
            formData.specialRequest = formData.specialRequest.join(',')
            formData.specialRequest = formData.specialRequest + ','
          } else {
            formData.specialRequest = null
          }
          resolve(formData)
          return
        })
      })
    },
    // 处理TourInfo变化
    handleTourInfoChange () {
      this.$emit('change')
    },
    // 保存数据
    async handleSave() {
      this.saving = true
      try {
        const formData = await this.validateTourForm()
        
        const submitData = {
          roomPreferred: formData.roomPreferred,
          mealsRequest: formData.mealsRequest,
          specialRequest: formData.specialRequest,
          specialNote: formData.specialNote,
          ffpList: this.$refs.customerAirlines.dataList,
          id: this.customerId
        }
        const response = await CustomerApi.saveCusRequest(submitData)
        if (!this.mixinProcessHasBizErrorNotification(response)) {
          this.mixinProcessSuccessNotification('Save success.')
          this.$emit('update')
          this.loadData()
        }
      } catch (error) {
        console.error('Save error:', error)
      } finally {
        this.saving = false
      }
    },
    handleCancel () {
      this.$emit('cancel')
    },
  },
  watch: {
    tourData: {
      deep: true,
      handler(newVal) {
        this.editData = JSON.parse(JSON.stringify(newVal))
        this.loadData()
      },
      immediate: true
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .ant-col .ant-form-item-label {
   font-weight: 600;
}
.plate-title {
  font-weight: bold;
  font-size: 1rem;
  line-height: 32px;
  padding-top: 10px;
}
.plate-title:before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 15px;
  margin-right: 6px;
  background: #1890ff;
  position: relative;
  top: 2px;
}
.custom-section-box .item ::v-deep .ant-col{
  padding: 0;
}
.custom-section-box .item .title{
  padding: 15px 0 5px 0px;
}
</style>
